import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import type { ContractReview } from './types';
import { formatMaintenanceTarget } from './types';

type Props = {
  contract: ContractReview;
};

// Per-car KPI targets, grouped by property. Self-contained so it can be
// dropped into the KPIs tab, a dedicated tab, or the property detail.
export const ContractCarKpiTable = ({ contract }: Props) => {
  const propertiesWithCars = contract.properties.filter((p) => p.cars.length > 0);

  if (propertiesWithCars.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No per-car KPI targets on this contract.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {propertiesWithCars.map((property) => (
        <Box key={property.id}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            {property.name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {property.cars.length} {property.cars.length === 1 ? 'elevator' : 'elevators'}
          </Typography>
          <TableContainer sx={{ mt: 0.5 }}>
            <Table size="small" sx={{ minWidth: 540 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Car</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>Maintenance</TableCell>
                  <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                    Reg. callbacks/yr
                  </TableCell>
                  <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                    Emg. callbacks/yr
                  </TableCell>
                  <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                    Reg. response
                  </TableCell>
                  <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                    Emg. response
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {property.cars.map((car) => (
                  <TableRow key={car.carId}>
                    <TableCell>{car.carName}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {formatMaintenanceTarget(car)}
                    </TableCell>
                    <TableCell align="right">≤ {car.regularCallbackRate}</TableCell>
                    <TableCell align="right">≤ {car.emergencyCallbackRate}</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                      ≤ {car.regularCallbackResponseTime} min
                    </TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                      ≤ {car.emergencyCallbackResponseTime} min
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </Stack>
  );
};
